<template>
  <v-app>
    <!-- Header -->
    <v-app-bar app color="primary">
      <v-toolbar-title class="white--text">Nabafzar Iranian</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text href="#pages" class="white--text">Pages</v-btn>
    </v-app-bar>

    <!-- Hero Section -->
    <v-parallax height="600" src="/media/bg/bg-1.jpg">
      <v-container fill-height fluid>
        <v-layout align-center justify-center column>
          <h1 class="display-2 white--text">Welcome to TOS UI COMPONENTS</h1>
        </v-layout>
      </v-container>
    </v-parallax>

    <!-- Services Section -->
    <v-container id="pages" class="my-5">
      <h2 class="headline text-center mt-5 m-5">Pages</h2> <!-- Add margin-top -->
      <v-layout row wrap>
        <v-flex xs12 sm6 md4>
          <a href='/#/berthmonitoring'>
            <v-card class="custom-card">
              <v-card-title>Yard View</v-card-title>
              <v-card-text>
                Monitor terminal and the vessels inside terminal.
              </v-card-text>
            </v-card>
          </a>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <a href='/#/vessel-profile/1'>
            <v-card class="custom-card">
              <v-card-title>Vessel Profile</v-card-title>
              <v-card-text>
                Vessel Profile Page
              </v-card-text>
            </v-card>
          </a>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <a href='/#/berthplanningSvg'>
            <v-card class="custom-card">
              <v-card-title>Berth Chart</v-card-title>
              <v-card-text>
                Description of Service 3.
              </v-card-text>
            </v-card>
          </a>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <a href='/#/vessel-monitoring/1'>
            <v-card class="custom-card">
              <v-card-title>Vessel Monitoring</v-card-title>
              <v-card-text>
                Vessel Monitoring Page
              </v-card-text>
            </v-card>
          </a>
        </v-flex>
      </v-layout>
    </v-container>


    <!-- Footer -->
    <v-footer app>
      <v-layout justify-center>
        <span>&copy; 2025 Nabafzar Iranian - v{{ appVersion }}</span>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  computed: {
    appVersion() {
       return APP_VERSION;
    }
  }
}
</script>

<style scoped>
/* Custom CSS class to add margin-bottom to cards */
.custom-card {
  margin-bottom: 20px;
}
</style>
